import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptIcon from "@mui/icons-material/Receipt";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import BarChartIcon from "@mui/icons-material/BarChart";
import CalculateIcon from "@mui/icons-material/Calculate";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TagIcon from "@mui/icons-material/Tag";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import { Widgets } from "@mui/icons-material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MessageIcon from "@mui/icons-material/Message";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import SettingsIcon from "@mui/icons-material/Settings";
import {
	Archive,
	Home,
	SquareGanttChart,
	Truck,
	ClipboardList,
	Printer,
	FileText,
} from "lucide-react";

export const pageToIcon = (page: string, sx: any) => {
	switch (page) {
		case "dashboard-home":
			return <Home size={16} style={sx} />;
		case "chats":
			return <MessageIcon sx={sx} />;
		case "dashboard":
		case "auftraege":
			return <DashboardIcon sx={sx} />;
		case "agenda":
			return <SquareGanttChart size={16} style={sx} />;
		case "organization":
			return <CorporateFareIcon sx={sx} />;
		case "debitoren":
			return <CalculateIcon sx={sx} />;
		case "statistics":
			return <BarChartIcon sx={sx} />;
		case "monthly-invoices":
			return <ReceiptIcon sx={sx} />;
		case "job-document-templates":
			return <WorkspacesIcon sx={sx} />;
		case "auftragsformulare":
			return <ClipboardList size={16} style={sx} />;
		case "form-builder":
			return <Widgets sx={sx} />;
		case "tariff":
			return <TagIcon sx={sx} />;
		case "catalogs":
			return <TagIcon sx={sx} />;
		case "article":
			return <DocumentScannerIcon sx={sx} />;
		case "archive":
			return <Archive size={16} style={sx} />;
		case "recycle-bin":
			return <DeleteIcon sx={sx} />;
		case "lieferungen":
			return <Truck size={16} style={sx} />;
		case "fremdlabore":
			return <ShoppingCartIcon sx={sx} />;
		case "job-configuration":
			return <SettingsIcon sx={sx} />;
		case "drucker":
			return <Printer size={16} style={sx} />;
		case "druckerauftraege":
			return <FileText size={16} style={sx} />;
		default:
			return null;
	}
};
